module.exports = require("react-intl/locale-data/zh");